var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-buycoin"},[_c('div',{staticClass:"otc-container-other"},[_c('top-bar'),(_vm.$route.name != 'coin')?_c('router-view'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }